export default "__VITE_ASSET__CKzhlw9z__"